/// <reference types="vite/client" />
import { createClient } from '@supabase/supabase-js';
import type { Database } from './src/types/supabase';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
     throw new Error('Supabase URL and anon key must be provided');
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
     auth: {
          persistSession: true, // Mantém a sessão entre recarregamentos (F5)
          autoRefreshToken: true, // Mantém o refresh automático do token
          detectSessionInUrl: false, // Não detecta sessão na URL
          storageKey: 'cantina-admin-auth-token', // Chave personalizada para o token
          storage: localStorage, // Usa localStorage para persistir a sessão
          flowType: 'pkce' // Usar PKCE flow para maior segurança
     },
     global: {
          headers: {
               'X-Client-Info': 'cantina-admin-web'
          }
     }
});

export type SupabaseClient = typeof supabase;